import { ILocation } from "../../../../utils/AnnounceInterfaces";
import { Map } from "../../../Map/Map";
import React from "react";

export function StepThree(props: {
    values: ILocation;
    handleChange: (longitude: number, latitude: number) => void;
    handleNext: () => void;
    autoGeolocate: boolean;
    startLongitude?: number;
    startLatitude?: number;
    searchTypeName?: string;
}) {
    //   console.log("values", props.values);
    React.useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);
    return (
        <Map
            setLocation={true}
            autoGeolocate={props.autoGeolocate}
            handleChange={props.handleChange}
            handleNext={props.handleNext}
            startZoom={12}
            startLongitude={props.startLongitude}
            startLatitude={props.startLatitude}
        />
    );
}
